import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import CrmBanner from "./CrmBanner";
import CRMInfo from "./CrmInfo";
function CrmTool() {
    return (
        <>
            <Header />
            <main>
                <CrmBanner/>
                <CRMInfo/>
            </main>
            <Footer />
        </>
    );
}

export default CrmTool;
